export function FusebaseLogoSmallSecond() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M16.5215 4V5.43047H18.5687V7.49243H20V4H16.5215Z" fill="currentColor" />
      <path d="M4 7.48341H5.43128V5.43956H7.4944V4.00909H4V7.48341Z" fill="currentColor" />
      <path d="M16.5033 18.5605H18.5687V16.5144H19.9999V19.9909H16.5033V18.5605Z" fill="currentColor" />
      <path d="M5.43128 16.5053H4V20H7.47855V18.5695H5.43128V16.5053Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9827 8.07185H12.9869L16.4836 14.1287L15.4826 15.8602H8.48699L7.486 14.1287L10.9827 8.07185Z"
        fill="currentColor"
      />
    </svg>
  );
}
